import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import StarRatings from "react-star-ratings";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import InviteUsersToReview from "./InviteUsersToReview";
import InviteDemoUsersToReview from "./InviteDemoUsersToReview";
import { inviteReview } from "../../api/UserApi";
import Button from "../Users/Button";
import defaultQuestions from "./questions.json";
import questionTypes from "./questionTypes.json";

const Reviews = () => {
  const location = useLocation();
  const history = useHistory();
  const [liveScore, setLiveScore] = useState({ brand: 0, manager: 0 });
  const [numberOfReviews, SetNumberOfReviews] = useState({
    brand: 0,
    manager: 0,
  });
  const [reviewQuestions, setReviewQuestions] = useState({
    brand: defaultQuestions,
    manager: defaultQuestions,
  });
  const [ukRanking, setUKRanking] = useState({ brand: 1, manager: 1 });
  const [industryRanking, setIndustryRanking] = useState({
    brand: 1,
    manager: 1,
  });
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [review, setReview] = useState({ brand: null, manager: null });
  const [reviews, setReviews] = useState({ brand: [], manager: [] });
  const [users, setUsers] = useState([]);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState("brand");
  const [indexEditing, setIndexEditing] = useState(null);
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setLoading(true);
      Firebase.getAllBrands(async (allbrands) => {
        const brands = allbrands.map((obj, id) => ({ ...obj, id }));
        // Sort brands by livescore so that we can get the ranks
        brands.sort(
          (obj1, obj2) => (obj2.liveScore || 0) - (obj1.liveScore || 0)
        );
        const id = brands.findIndex((obj) => obj && obj.id === brand);
        // Find the UK ranks
        const ukIndex = brands
          .filter((obj) => obj && (!obj.territory || obj.territory === "UK"))
          .findIndex((obj) => obj.id === brand);
        const brand_data = brands[id];
        if (brand_data.reviewQuestions) {
          if (brand_data.reviewQuestions["brand"])
            setReviewQuestions((prev) => ({
              ...prev,
              ...brand_data.reviewQuestions,
            }));
          else
            setReviewQuestions((prev) => ({
              ...prev,
              brand: brand_data.reviewQuestions,
              manager: brand_data.reviewQuestions,
            }));
        }
        setBrandData(brand_data);
        setLiveScore((prev) => {
          if (brand_data.liveScore && brand_data.liveScore["brand"]) {
            return { ...prev, ...brand_data.liveScore };
          } else {
            return { ...prev, brand: brand_data.liveScore || 0 };
          }
        });
        setIndustryRanking((prev) => ({
          ...prev,
          brand: id + 1,
          manager: id + 1,
        }));
        setUKRanking((prev) => ({
          ...prev,
          brand: ukIndex !== undefined ? ukIndex + 1 : "None",
          manager: ukIndex !== undefined ? ukIndex + 1 : "None",
        }));
        setBrand(brand);
        setRole(role);
        setUserName(username);

        // Get all reviews for this brand
        Firebase.getReviews(brand_data.name, (reviews) => {
          const brandReviewQuestions = brand_data.reviewQuestions
            ? brand_data.reviewQuestions["brand"] || brand_data.reviewQuestions
            : defaultQuestions;
          let questions = brandReviewQuestions || reviewQuestions["brand"];
          const review = questions.reduce((prevReview, item) => {
            const sum = reviews.reduce((prev, cur) => prev + cur[item.key], 0);
            prevReview[item.key] = sum / (reviews.length || 1);
            return prevReview;
          }, {});
          setLoading(false);
          setReviews((prev) => ({ ...prev, brand: reviews }));
          setReview((prev) => ({ ...prev, brand: review }));
          SetNumberOfReviews((prev) => ({ ...prev, brand: reviews.length }));
        });

        Firebase.getRepManagerReviews(brand_data.name, (reviews) => {
          const brandReviewQuestions = brand_data.reviewQuestions
            ? brand_data.reviewQuestions["manager"] ||
              brand_data.reviewQuestions
            : defaultQuestions;
          let questions = brandReviewQuestions || reviewQuestions["manager"];
          const review = questions.reduce((prevReview, item) => {
            const sum = reviews.reduce((prev, cur) => prev + cur[item.key], 0);
            prevReview[item.key] = sum / (reviews.length || 1);
            return prevReview;
          }, {});
          setReviews((prev) => ({ ...prev, manager: reviews }));
          setReview((prev) => ({ ...prev, manager: review }));
          SetNumberOfReviews((prev) => ({ ...prev, manager: reviews.length }));
        });
        // Get community users for this brand
        loadUser(brand_data.name);
      });
    }
  }, [location]);
  const loadUser = async (brand) => {
    let users = await Firebase.getAllUsersInBrand(brand);
    let userPromise = users.map(async (user) => {
      const { eco_id } = user;
      let eco_data = {};
      if (eco_id) eco_data = await Firebase.getEcoUserbyId(eco_id);
      return { ...user, ...eco_data };
    });
    Promise.all(userPromise).then((res) => {
      let sorted = res.sort((a, b) => {
        if (b.phonenumber) return 1;
        else if (a.phonenumber) return -1;
      });
      setUsers(sorted);
    });
  };
  const onInvite = async (inviterIds) => {
    const inviters = inviterIds
      .map((obj) => users.find((u) => u.id === obj))
      .filter((obj) => obj && obj.phonenumber);
    const brandName = brand_data.name.replace(/\s/g, "");
    await Promise.all(
      inviters.map((obj) =>
        inviteReview(obj.firstname, brandName, obj.phonenumber, obj.id)
      )
    );
  };
  const saveReviewItem = () => {
    setIndexEditing(null);
    Firebase.updateBrandDataById(brand, { reviewQuestions: reviewQuestions });
  };

  const handleChangeQuestion =
    (index) =>
    ({ target }) => {
      const newReviewQuestions = [...reviewQuestions[currentTab]];
      newReviewQuestions[index].text = target.value;
      setReviewQuestions((prev) => ({
        ...prev,
        [currentTab]: newReviewQuestions,
      }));
    };
  const handleChangeQuestionType = (index) => (value) => {
    const newReviewQuestions = [...reviewQuestions[currentTab]];
    newReviewQuestions[index].key = value.value;
    setReviewQuestions((prev) => ({
      ...prev,
      [currentTab]: newReviewQuestions,
    }));
  };
  return (
    <div id="review-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      {loading ? (
        <div className="loading">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      ) : (
        <main id="main-container" className="reviews-content">
          <div className="tab-container">
            <button
              className="btn btn-white"
              style={{
                backgroundColor:
                  currentTab === "brand" ? brand_data.hex : "white",
                color:
                  currentTab === "brand"
                    ? brand_data.white
                      ? "white"
                      : "black"
                    : "black",
              }}
              onClick={() => setCurrentTab("brand")}
            >
              Review of {brand_data.name}
            </button>
            {
              <button
                className="btn btn-white"
                style={{
                  backgroundColor:
                    currentTab === "manager" ? brand_data.hex : "white",
                  color:
                    currentTab === "manager"
                      ? brand_data.white
                        ? "white"
                        : "black"
                      : "black",
                }}
                onClick={() => setCurrentTab("manager")}
              >
                Review of Reps & Managers
              </button>
            }
          </div>
          {currentTab === "brand" && (
            <div className="buttons-container">
              <Button
                title="View review platform"
                onClick={() => {
                  window.open(
                    `https://reviewrobot.io/${(brand_data.name || "")
                      .replace(/\s/g, "")
                      .toLowerCase()}`,
                    "_blank"
                  );
                }}
              />
              <Button
                title="Invite members to review"
                isModal={true}
                targetValue="#invite_users_to_review"
              />
              <Button
                title="Invite light users to review"
                isModal={true}
                targetValue="#invite_demo_users_to_review"
              />
            </div>
          )}
          <div className="statics-row">
            <div className="header">Current live score</div>
            <StarRatings
              numberOfStars={10}
              starDimension="30px"
              rating={liveScore[currentTab]}
              starRatedColor={"rgb(254,193,47)"}
            />
          </div>
          <div className="statics-row">
            <div className="header">Number of reviews</div>
            {numberOfReviews[currentTab]}
          </div>
          {/* <div className="statics-row">
          <div className="header">UK ranking</div>
          {ukRanking}
        </div>
        <div className="statics-row">
          <div className="header">Industry ranking</div>
          {industryRanking}
        </div> */}
          {review &&
            review[currentTab] &&
            reviewQuestions[currentTab].map((item, index) => (
              <div className="statics-row">
                {indexEditing === index ? (
                  <div className="header">
                    <Select
                      onChange={handleChangeQuestionType(index)}
                      placeholder="Select..."
                      options={Object.keys(questionTypes).map((key) => ({
                        label: questionTypes[key],
                        value: key,
                      }))}
                      value={{
                        label: questionTypes[item.key],
                        value: item.key,
                      }}
                    />
                  </div>
                ) : (
                  <div className="header">{questionTypes[item.key]}</div>
                )}
                <StarRatings
                  numberOfStars={10}
                  starDimension="30px"
                  rating={review[currentTab][item.key]}
                  starRatedColor={"rgb(254,193,47)"}
                />
                {/* <div style={{ width: 20 }}></div>
                <div className="right-pane">
                  {indexEditing === index ? (
                    <input
                      type="text"
                      className="form-control form-control-md"
                      onChange={handleChangeQuestion(index)}
                      value={reviewQuestions[currentTab][index].text}
                    />
                  ) : (
                    <p>
                      {reviewQuestions[currentTab][index].text.replaceAll(
                        "[brand_name]",
                        brand_data.name
                      )}
                    </p>
                  )}

                  {indexEditing === index ? (
                    <button
                      className="btn"
                      style={{ marginLeft: 20 }}
                      onClick={saveReviewItem}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="btn"
                      style={{ marginLeft: "auto" }}
                      onClick={() => setIndexEditing(index)}
                      disabled={indexEditing !== null}
                    >
                      Edit
                    </button>
                  )}
                </div> */}
              </div>
            ))}
        </main>
      )}

      <InviteUsersToReview
        brandname={brand_data.name}
        users={users.filter(
          (obj) =>
            !reviews[currentTab].find((r) => r.reviewer === obj.id) &&
            obj.phonenumber
        )}
        onInvite={onInvite}
      />
      <InviteDemoUsersToReview
        brandname={brand_data.name}
        users={users.filter(
          (obj) =>
            !reviews[currentTab].find((r) => r.reviewer === obj.id) &&
            !obj.phonenumber
        )}
      />
    </div>
  );
};
export default Reviews;



// WEBPACK FOOTER //
// ./src/screens/Reviews/index.js